import React, { useState, useEffect } from 'react';
import LoadingIcon from '@m2h/components/LoadingIcon';

export const GlobalLoadingComponent = () => {
  const [visible, setVisible] = useState(false);

  const changeVisible = (visible: boolean) => {
    setVisible(visible);
  };

  useEffect(() => {
    Mach.on('onMachActivityIndicatorChange', changeVisible);
    return () => {
      Mach.off('onMachActivityIndicatorChange', changeVisible);
    };
  }, []);

  if (!visible) return null;

  return <LoadingIcon showBorder />;
};

export default GlobalLoadingComponent;
